"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "brissago-valtravaglia": {
    "f71d85a0": [{
      "hkey": "4d19735c",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "motto-inferiore": [{
      "hkey": "4d19735c",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "brissago-valtravaglia"
    }],
    "ee33513c": [{
      "hkey": "4d19735c",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "motto-superiore": [{
      "hkey": "4d19735c",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "brissago-valtravaglia"
    }],
    "9e660dc0": [{
      "hkey": "5ee08608",
      "slug": "brissago-valtravaglia",
      "name": "Brissago-Valtravaglia",
      "primary": true,
      "skipSearch": false
    }],
    "novello": [{
      "hkey": "5ee08608",
      "slug": "brissago-valtravaglia",
      "name": "Brissago-Valtravaglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;